import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import { Row, Col, Button, Alert } from 'reactstrap'
import { useTranslation } from 'react-i18next'

const EventListModule = (props) => {
  const { config, machine, status } = props
  const [current, send] = machine
  const { access_event_groups } = current.context
  const { i18n } = useTranslation()

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed' ? send('REOPEN_EVENTSTEP') : null
        }
      >
        <span>
          <i className="fa fa-map-marker me-2" aria-hidden="true"></i>
          {i18n.t('event_list_module.module_title')}
        </span>
      </ModuleHeader>
      <ModuleBody status={status}>
        <EventsSection
          eventGroups={access_event_groups}
          isFetching={current.matches({ eventStep: 'fetchingEvents' })}
          send={send}
        />
      </ModuleBody>
      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

const EventsSection = ({ eventGroups, event, isFetching, send }) => {
  const { i18n } = useTranslation()

  if (isFetching) {
    return (
      <Alert color="light" className="d-flex align-items-center">
        <i className="fa fa-hourglass-half me-2" aria-hidden="true"></i>
        {i18n.t('event_module.loading_events')}...
      </Alert>
    )
  }

  if (eventGroups.length > 0) {
    return (
      <Row className="justify-content-start g-2">
        {eventGroups[0].events.map((event) => (
          <Col key={event.id} xs="12" md="2">
            <Button
              color="primary"
              className="w-100 text-white py-1 my-2"
              onClick={() => send({ type: 'EVENT_SELECTION', event })}
            >
              <i className="far fa-clock me-1" aria-hidden="true"></i>
              {event.time}
            </Button>
          </Col>
        ))}
      </Row>
    )
  }

  return (
    <Alert color="light" className="text-center">
      {i18n.t('event_module.events_not_available')}
    </Alert>
  )
}

export default EventListModule
